<template>
  <el-form ref="addFrom" :model="addFrom" :rules="rules" label-width="110px">
    <el-row>
      <el-col :span="24">
        <el-form-item label="课题属性" prop="ktsx">
          <el-select
            v-model="addFrom.ktsx"
            filterable
            default-first-option
            style="width: 100%"
            placeholder="请选择课题属性"
            @change="handleChangeKt"
          >
            <el-option
              v-for="item in ktsxOptions"
              :key="item.dictValue"
              :label="item.dictLabel"
              :value="item.dictValue"
            />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="所属阶段" prop="ssjd">
          <el-select
            v-model="addFrom.ssjd"
            filterable
            default-first-option
            style="width: 100%"
            placeholder="请选择所属阶段"
          >
            <el-option
              v-for="item in ssjdOptions"
              :key="item.dictValue"
              :label="item.dictLabel"
              :value="item.dictValue"
            />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item
          label="课题安排"
          :required="true"
          v-if="addFrom.ssjd == '3'"
        >
          <el-radio-group v-model="addFrom.ktap">
            <el-radio :label="1">一审安排</el-radio>
            <el-radio :label="2">二审安排</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-col>

      <el-col :span="24">
        <el-form-item label="评审评委" prop="pws">
          <el-select
            v-model="addFrom.pws"
            filterable
            multiple
            style="width: 100%"
            placeholder="请选择评委"
          >
            <el-option
              v-for="item in pswyOptions"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
      </el-col>

      <el-col :span="24">
        <el-form-item label="课题选择" prop="cids">
          <el-select
            v-model="addFrom.cids"
            filterable
            multiple
            clearable
            style="width: 100%"
            placeholder="请选择课题"
          >
            <el-option
              v-for="item in ktsOptions"
              :key="item.course_id"
              :label="item.name"
              :value="item.course_id"
            />
          </el-select>
        </el-form-item>
      </el-col>

      <el-col :span="24">
        <el-form-item label="开始时间" prop="qsrq" key="10">
          <el-date-picker
            type="datetime"
            placeholder="选择日期"
            v-model="addFrom.qsrq"
            :clearable="false"
          ></el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-row>
          <el-col :span="24">
            <el-form-item label="结束时间" prop="jsrq" key="10">
              <el-date-picker
                type="datetime"
                placeholder="选择日期"
                v-model="addFrom.jsrq"
                :clearable="false"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="24">
        <el-form-item label="会议纪要员" prop="hyjyy">
          <treeselect
            v-model="addFrom.hyjyy"
            placeholder="请选择"
            :options="deptUser"
            :disable-branch-nodes="true"
            :show-count="true"
            value-consists-of="LEAF_PRIORITY"
            no-results-text="未搜到任何结果"
            :clear-on-select="true"
            :normalizer="normalizer"
            style="width: 100%; line-height: 18px; margin-top: 4px"
            :limit="1"
            :max-height="200"
          />
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="评审方式" prop="psfs">
          <el-select
            v-model="addFrom.psfs"
            filterable
            default-first-option
            style="width: 100%"
            placeholder="请选择评审方式"
          >
            <el-option label="线上" value="1"></el-option>
            <el-option label="线下" value="2"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="关键物">
          <el-input
            v-model="addFrom.words"
            maxlength="50"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { mapGetters } from "vuex";
import { getDictData } from "@/api/task.js";
import { formatMomentDate, sizeFormat, checkVal } from "@/utils/utils";
import moment from "moment";
import {
  getCourseQueryCondition,
  assignList,
  stepArrangeSave,
} from "@/api/course.js";
export default {
  name: "arrangeAdd",
  computed: {
    ...mapGetters(["deptUser"]),
  },
  components: { Treeselect },
  props: ["mxParams"],
  data() {
    return {
      normalizer(node) {
        return {
          children: node.users,
        };
      },
      rules: {
        ktsx: [
          { required: true, message: "课题属性不能为空", trigger: "change" },
        ],
        ssjd: [
          { required: true, message: "所属阶段不能为空", trigger: "change" },
        ],
        pws: [{ required: true, message: "课题评委不能为空", trigger: "blur" }],
        cids: [
          { required: true, message: "课题选择不能为空", trigger: "blur" },
        ],
        qsrq: [
          { required: true, message: "开始时间不能为空", trigger: "change" },
        ],
        jsrq: [
          { required: true, message: "结束时间不能为空", trigger: "change" },
        ],
        hyjyy: [
          { required: true, message: "会议纪要员不能为空", trigger: "change" },
        ],
        psfs: [
          { required: true, message: "评审方式不能为空", trigger: "change" },
        ],
      },
      addFrom: {
        type: "0",
        ktsx: this.mxParams.ktsx,
        ssjd: this.mxParams.ssjd,
        ktap: 1,
        cids: null,
        pws: null,
        qsrq: null,
        jsrq: null,
        hyjyy: null,
        psfs: null,
        words: null,
      },
      ktsxOptions: [],
      ssjdOptions: [],
      allSsjdOptions: [],
      jsSsjdOptions: [],
      yjSsjdOptions: [],
      pswyOptions: [],
      ktsOptions: [],
      parentDialog: false,
    };
  },

  created() {
    if (!this.deptUser || this.deptUser.length == 0) {
      this.$store.dispatch("common/getDeptUser");
    }
    //课题属性
    getDictData("pmp_course_group", 1).then((res) => {
      if (res.code === 0) {
        this.ktsxOptions = res.data;
      }
    });
    //所属阶段
    getDictData("pmp_course_step", 1).then((res) => {
      if (res.code === 0) {
        this.ssjdOptions = res.data.filter(
          (ele) =>
            ele.dictLabel.indexOf("审") != -1 ||
            ele.dictLabel.indexOf("质量评分") != -1
        );
        this.allSsjdOptions = this.ssjdOptions;

        for (let i of this.allSsjdOptions) {
          if (i.dictValue != 13) {
            this.jsSsjdOptions.push(i);
          }
        }
        for (let i of this.allSsjdOptions) {
          if (i.dictValue != 15) {
            this.yjSsjdOptions.push(i);
          }
        }

        if (this.addFrom.ktsx == 2) {
          this.ssjdOptions = this.jsSsjdOptions;
        } else {
          this.ssjdOptions = this.yjSsjdOptions;
        }
      }
    });
    this.getPswyOptions();
    this.handleChangeKt();
  },
  methods: {
    getPswyOptions() {
      //评委委员
      const params = { type: 6, ktsx: this.addFrom.ktsx };
      getCourseQueryCondition(params).then((res) => {
        if (res.code === 0) {
          this.pswyOptions = res.data;
        }
      });
    },
    handleChangeKt() {
      let ktsx = this.addFrom.ktsx;
      let nf = this.mxParams.nf;
      const params = { ktsx: ktsx, nf: nf };
      if (this.addFrom.ktsx == 2) {
        this.ssjdOptions = this.jsSsjdOptions;
      } else {
        this.ssjdOptions = this.yjSsjdOptions;
      }
      assignList(params).then((res) => {
        if (res.code === 0) {
          this.ktsOptions = res.data;
        }
      });
      this.getPswyOptions();
    },
    handleAdd() {
      this.$refs["addFrom"].validate((valid) => {
        if (valid) {
          let qsrq = moment(this.addFrom.qsrq).format("YYYY-MM-DD HH:mm:ss");
          let jsrq = moment(this.addFrom.jsrq).format("YYYY-MM-DD HH:mm:ss");
          if (qsrq > jsrq) {
            this.$message.error("开始时间不能大于结束时间！");
            return false;
          }
          let cids = this.addFrom.cids.join(",");
          let pws = this.addFrom.pws.join(",");

          if (this.addFrom.ssjd != "3") {
            // if (this.addFrom.ssjd == "6" && this.addFrom.ktsx == "2") {
            //   this.addFrom.ktap = 2;
            // } else {
            this.addFrom.ktap = 1;
            // }
          }
          const params = { ...this.addFrom, qsrq, jsrq, cids, pws };

          stepArrangeSave(params).then((res) => {
            if (res.code == 0) {
              this.$message.success(res.msg);
              this.$emit("giveFather", this.parentDialog);
            } else {
              this.$message.error(res.msg);
            }
          });
        }
      });
    },
    giveFather() {
      this.parentDialog = false;
    },
  },
};
</script>
<style lang="less" scoped>
</style>